import React from 'react'

const AiIcon = () => (
    <svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 540 540'>
        <path
            stroke='#3c3c3b'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='15.6'
            d='M9.6,225.3c151.1,0,217.6-65.8,217.6-215.3,0,149.5,66.5,215.3,217.6,215.3-151.1,0-217.6,65.8-217.6,215.3,0-149.5-66.5-215.3-217.6-215.3Z'
        />
        <path
            stroke='#e74e0f'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='15.6'
            d='M286.6,409.4c84.7,0,121.9-36.9,121.9-120.6,0,83.8,37.3,120.6,121.9,120.6-84.7,0-121.9,36.9-121.9,120.6,0-83.8-37.3-120.6-121.9-120.6Z'
        />
    </svg>
)

export default AiIcon
